export default __webpack_public_path__ + "static/media/MSExcel_Example_4.c0698aa9.png";